import { i18n } from '@lingui/core'
import { t } from '@lingui/macro'
import { Text, View } from '@react-pdf/renderer'
import { isConditionMet } from '../../formHelpersConditions'
import {
    defaultFormPdfFontFamily,
    formPDFStyles,
    inuktitutFormPdfFontFamily
} from '../../pdf-components/FormPdf'
import { formMinFilesConditionsToText } from '../../pdf-components/formPdfUtils'
import { pdfDefaultFontSize } from '../../pdf-components/PDFCommon'

export const FormUploadFilesFillablePdf = ({
  value,
  values,
  elementType,
  typeProps,
  langVersion,
  title,
  helpText,
  tooltip,
  altLabelPlacement,
  conditions = [],
  idToRenderIndex,
  elementsMap,
  requiredText,
  ...props
}) => {
  let minNumberOfFiles = 1
  let baseRequired = 1
  conditions.forEach(c => {
    if (c.minFiles && c.minFiles > minNumberOfFiles) {
      minNumberOfFiles = c.minFiles
      const { conditionMet } = isConditionMet({
        condition: c,
        connectedMap: props.connectedMap,
        values,
        elementsMap
      })
      if (conditionMet) {
        baseRequired = c.minFiles
      }
    }
  })

  const conditionTexts = conditions
    .filter(c => c.conditionTarget && c.state === 'minFiles' && !c.sfField)
    .map(c => {
      const subText = formMinFilesConditionsToText(c, idToRenderIndex, elementsMap)
      if (!subText) return null
      return `(${i18n._(t`PDF_MIN`)} ${c.minFiles}) ${subText}`
    })
    .filter(Boolean) ?? []

  const isConditionText = conditionTexts.length > 0

  return (
    <>
      <Text
        style={{
          fontSize: pdfDefaultFontSize - 2,
          fontStyle: 'italic',
          marginBottom: 8,
          fontFamily:
                  langVersion === 'iu-cans'
                    ? inuktitutFormPdfFontFamily
                    : defaultFormPdfFontFamily
        }}
      >
        {isConditionText && conditionTexts.join('\n\n')}
      </Text>
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          fontFamily:
            langVersion === 'iu-cans'
              ? inuktitutFormPdfFontFamily
              : defaultFormPdfFontFamily,
          fontSize: pdfDefaultFontSize,
          marginBottom: 4
        }}
      >
        <View style={formPDFStyles.checkbox} />
        <Text
          style={{
            fontFamily:
              langVersion === 'iu-cans'
                ? inuktitutFormPdfFontFamily
                : defaultFormPdfFontFamily,
            fontSize: pdfDefaultFontSize,
            marginLeft: 8
          }}
        >
          {tooltip ? `[${tooltip}] ` : ''}
          {'1. '}
        </Text>
      </View>
      {[...Array(minNumberOfFiles - 1)].map((empty, index) => {
        const fileNumber = index + 2
        return (
          <View
            key={index}
            style={{
              display: 'flex',
              flexDirection: 'row',
              fontFamily:
            langVersion === 'iu-cans'
              ? inuktitutFormPdfFontFamily
              : defaultFormPdfFontFamily,
              fontSize: pdfDefaultFontSize,
              marginBottom: 4
            }}
          >

            <View style={formPDFStyles.checkbox} />
            <Text
              style={{
                fontFamily:
              langVersion === 'iu-cans'
                ? inuktitutFormPdfFontFamily
                : defaultFormPdfFontFamily,
                fontSize: pdfDefaultFontSize,
                marginLeft: 8
              }}
            >
              {fileNumber}.
              {' '}
              {fileNumber > baseRequired && i18n._(t`REQUIRED_IF_CONDITION_FULFILLED`)}
            </Text>
          </View>
        )
      })}
    </>
  )
}
